
import { convertCurrency } from "../helpers";
import debounce from 'lodash/debounce';
import Cleave from 'cleave.js';
export class OtherAmountInput {
    otherContainer;
    otherInput;
    sufix;
    sufixClass;
    currencyInputEl;
    initialValue;

    //callback
    onOtherAmountUpdate;

    constructor(elMap = {inputId, suffixId, initialValue, containerWrapperClass, sufixClass}, currencyInputEl) {
        this.otherInput = document.getElementById(elMap.inputId);
        this.sufixClass = elMap.sufixClass || "currency-sufix";
        this.otherContainer = elMap.containerWrapperClass? document.getElementsByClassName(elMap.containerWrapperClass): this.otherInput?.parentNode?? undefined;
        if (elMap.containerWrapperClass) {
            this.otherContainer = document.querySelector('.'+elMap.containerWrapperClass)?? this.otherContainer;
        }
        this.currencyInputEl = currencyInputEl;
        var sufixLabel = this.otherInput.previousElementSibling;
        if ( sufixLabel?.classList.contains(this.sufixClass)) {
            this.sufix = sufixLabel;
        } else {
            this.sufix= document.createElement("span"); 
            this.sufix.id = elMap.suffixId;
        }
       
        if (this.otherInput && this.otherInput.type === "number") {
            this.otherInput.type = "text";
            this.otherInput.inputMode = "decimal";
        }

        this.initialValue = elMap.initialValue?? 0;
        if (this.otherInput) {
            this.otherInput.value = this.initialValue;
        }

        this.createCallbacks();
    }
    createCallbacks() {
        if (!this.otherInput) return;

        const debouncedInput = debounce(this.updateOtherAmount, 300);
        this.sufix.textContent = currency(this.currencyInputEl?.value?? "");
        if (!this.sufix.classList.contains(this.sufixClass)){
            this.otherInput.style.paddingLeft = this.sufix.textContent.length === 1 ? "25px" : "50px";
            this.sufix.classList.add(this.sufixClass);
            this.otherInput.parentElement?.append(this.sufix);
        } 
        this.otherInput.addEventListener("input", ({ target: { value }}) => debouncedInput({ target: { value }}, this.currencyInputEl?.value?? "USD", this.onOtherAmountUpdate)); 
        const otherAmount = new Cleave('#'+this.otherInput.id, {
            numeral: true,
            numeralDecimalMark: '.',
            delimiter: ','
        });
    }

    async updateOtherAmount({ target: { value }}, currentCurrency, callback) {
        let newAmount = !value? 0 : String(value).replaceAll(',', '');
        const numValue = parseFloat(newAmount);

        if (isNaN(numValue) || numValue <= 0) { 
         value = '0';
        }
        const usdValue = currentCurrency !== "USD"
            ? await convertCurrency(currentCurrency, "USD", value)
            : value;

        callback?.(value, String(usdValue).replaceAll(',', '')); //save amounts in storage
    }
}

const currency = (currencyCode) => {
    return currencyCode === 'USD' ? "$" : currencyCode + " ";
}